<ion-app class="etikto-theme ion-default-theme">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
